import React, { useContext } from 'react'
import { AuthContxt } from './AuthContext'
import Login from './Login/Login'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';

export default function ProtectedRoute({children}) {
    const {UserLoggedIn , setUserLoggedIn} = useContext(AuthContxt)
  return<>
   {UserLoggedIn ? children : <Login/>}
  </>
}
